// components/RoleRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import  {getCurrentUserRole}  from "../../misc/util";

const RoleRoute = ({ component: Component, allowedRoles, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        const user = getCurrentUserRole();

        if (!user) {
          return <Redirect to="/signin" />;
        }

        if (!allowedRoles.includes(user)) {
          return <Redirect to="/dashboard" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default RoleRoute;
